export default __webpack_public_path__ + "static/media/crypto-gif.c166ea9d.gif";